/**
 * Courses Route Resolver Middleware
 *
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  // Add any route related changed here
})
